module.exports = __webpack_public_path__ + "media/images/keeper-certified-icon-15c031c6.png";